import { Card } from "@mui/material";
import React, { useState } from "react";
import TestimonialsVideoComponent from "./TestimonialsVideoComponent";
import TestimonialsMobileView from "./TestimonialsMobileView";
import WasilSuccessStory from './images/wasil-success-story.jpg';
import AnantSuccessStory from './images/anant-success-story.jpg';
import ApurvaSuccessStory from './images/apura-success-story.jpg';
import AyushSuccessStory from './images/ayush-success-story.jpg';
import ShayanSuccessStory from './images/shyan_youtube.webp';
import NileshSuccessStory from './images/NileshVideo.webp';
import EyonSuccessStory from './images/EyonSuccessStory.webp';
import { AZURE_DEVOPS } from "../constants/AzureDevops";

export default function TestimonialsVideo(props) {
    const { isSmallScreen, setValue, heading } = props;
    const [viewMore, setViewMore] = useState(false);

    const ref = React.useRef(null);
    
      React.useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setValue(2);
            }
          },
          { threshold: 0.9 }
        );
    
        if (ref.current) {
          observer.observe(ref.current);
        }
    
        return () => {
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        };
      }, []);

    return (
        <React.Fragment>
            <div ref={ref} style={{ margin: isSmallScreen ? "4rem auto auto 20px" : "60px", marginBottom: "30px" }} id="testimonialsVideo">
                <span className={isSmallScreen ? 'only-heading-sm' : 'only-heading'}>Our Success </span>
                <span className={isSmallScreen ? 'gradient-heading-sm' : 'gradient-heading'}>Stories</span>
            </div>
            {
                isSmallScreen &&
                <div style={{margin: "auto"}}>
                <TestimonialsMobileView isSmallScreen={isSmallScreen} heading={heading}/>
                </div>
            }
            {!isSmallScreen &&
                <div style={{ marginBottom: "20px", display: "flex" }}>
                    <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={AyushSuccessStory} videoUrl={
                            'https://www.youtube.com/embed/Vx-Xs-2_75o?si=tcbvD0sVHWfjE7kd'}/>
                    </div>
                    <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={AnantSuccessStory} videoUrl={'https://www.youtube.com/embed/eA6r4AocL9g?si=tdzPMX3gPaYA-BHU'}/>
                    </div>

                </div>
            }
            {!isSmallScreen &&
                <div style={{ marginBottom: "20px", display: "flex" }}>
                    <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={ApurvaSuccessStory} videoUrl={'https://www.youtube.com/embed/DrID61L12Pc?si=IJBy_DEeKzzuyKc8'}/>
                    </div>
                    <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={EyonSuccessStory} videoUrl={'https://www.youtube.com/embed/4QX7UEgL6Ag?si=U_qR9QjrBW2Mns6J'}/>
                    </div>
                    {/* <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={WasilSuccessStory} videoUrl={'https://www.youtube.com/embed/HiQo4aDUWfs?si=C1BygYDbKNF47ICh'
                            }/>
                    </div> */}
                </div>
            }
            {(!isSmallScreen && viewMore) &&
            <div>
                <div style={{ marginBottom: "20px", display: "flex" }}>
                    <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={ShayanSuccessStory} videoUrl={'https://www.youtube.com/embed/t0l52vDZOLE?si=8h27oIG_L1xbsgAN'}/>
                    </div>
                    <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={NileshSuccessStory} videoUrl={'https://www.youtube.com/embed/nC4B0DqEu38?si=Qk78AoGTU2qj6FQW'}/>
                    </div>
                </div>
                <div style={{ marginBottom: "20px", display: "flex" }}>
                    {/* <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={EyonSuccessStory} videoUrl={'https://www.youtube.com/embed/4QX7UEgL6Ag?si=U_qR9QjrBW2Mns6J'}/>
                    </div> */}
                    {/* <div style={{ width: "50%" }}>
                        <TestimonialsVideoComponent isSmallScreen={isSmallScreen} imageUrl={NileshSuccessStory} videoUrl={
                            heading === AZURE_DEVOPS ?
                            '' :
                            'https://www.youtube.com/embed/nC4B0DqEu38?si=Qk78AoGTU2qj6FQW'}/>
                    </div> */}
                </div> 
            </div>
                
            }
            {!isSmallScreen &&
            <div style={{textAlign: "center", color: "blue", paddingTop: "10px", cursor: "pointer"}} onClick={(e)=>setViewMore(!viewMore)}>{
                viewMore ?
                "View Less" 
                :
                "View More"
                }
                </div>

            }
        </React.Fragment>
    );
}